var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgView = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uD83D\uDD39 Icon Color")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Template---Summary",
    transform: "translate(-366.000000, -205.000000)",
    fill: "#2962FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(246.000000, 84.103774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Template---Summary-(Subtitle)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Summary-Title",
    transform: "translate(0.000000, 0.896226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title",
    transform: "translate(37.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-visibility",
    transform: "translate(83.000000, 106.896226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD39-Icon-Color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875,1.35377358 C9.24375,1.35377358 11.35625,2.68502358 12.3875,4.79127358 C11.35625,6.89752358 9.24375,8.22877358 6.875,8.22877358 C4.50625,8.22877358 2.39375,6.89752358 1.3625,4.79127358 C2.39375,2.68502358 4.50625,1.35377358 6.875,1.35377358 L6.875,1.35377358 Z M6.875,0.103773585 C3.75,0.103773585 1.08125,2.04752358 0,4.79127358 C1.08125,7.53502358 3.75,9.47877358 6.875,9.47877358 C10,9.47877358 12.66875,7.53502358 13.75,4.79127358 C12.66875,2.04752358 10,0.103773585 6.875,0.103773585 Z M6.875,3.22877358 C7.7375,3.22877358 8.4375,3.92877358 8.4375,4.79127358 C8.4375,5.65377358 7.7375,6.35377358 6.875,6.35377358 C6.0125,6.35377358 5.3125,5.65377358 5.3125,4.79127358 C5.3125,3.92877358 6.0125,3.22877358 6.875,3.22877358 L6.875,3.22877358 Z M6.875,1.97877358 C5.325,1.97877358 4.0625,3.24127358 4.0625,4.79127358 C4.0625,6.34127358 5.325,7.60377358 6.875,7.60377358 C8.425,7.60377358 9.6875,6.34127358 9.6875,4.79127358 C9.6875,3.24127358 8.425,1.97877358 6.875,1.97877358 Z"
  }))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgView, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/view.f03d413b.svg";
export { ForwardRef as ReactComponent };